import React from "react";
import { motion } from "framer-motion";
import Footer from "../Base/Footer";
import Navbar from "./components/Navbar";

const user = {
  name: "Lauren Olivier",
  accountType: "EXECUTIVE",
  avatarUrl: "https://i.ibb.co/xqnrW3cK/woman-pfp.jpg",
  hasNotifications: true,
};

const portalPageStaggerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.08,
      delayChildren: 0.03,
    },
  },
};

const portalFadeUpVariants = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.34, ease: [0.22, 1, 0.36, 1] },
  },
};

const newsItems = [
  {
    title: "Why Apollo Actively Encourages Non-Profit Board Leadership",
    source: "Apollo Insights",
    href: "https://www.apollo.com/insights-news/insights/2025/10/why-apollo-actively-encourages-non-profit-leadership",
    cta: "Read article",
  },
  {
    title: "The Power of Employee-Led Philanthropy",
    source: "YouTube",
    href: "https://www.youtube.com/watch?v=Fcj1WgpLiYU",
    cta: "Watch video",
  },
];

export default function News() {
  return (
    <div className="ed-wrapper">
      <motion.div
        className="ed-main"
        initial="hidden"
        animate="show"
        variants={portalPageStaggerVariants}
      >
        <Navbar user={user} currentPage="news" />

        <motion.section className="hero-board bg-2" variants={portalFadeUpVariants}>
          <div className="hero-board__overlay" />
          <div className="hero-board__content">
            <h1 className="hero-board__title">News</h1>
            <p className="hero-board__subtitle">
              Perspectives and stories on how Apollo advances purpose-driven
              leadership and citizenship.
            </p>
          </div>
        </motion.section>

        <motion.section className="news-page" variants={portalFadeUpVariants}>
          <div className="news-page__inner">
            <div className="news-page__header">
              <h2 className="news-page__title">Latest Features</h2>
              <p className="news-page__subtitle">
                Explore recent Apollo content related to non-profit leadership
                and employee-led impact.
              </p>
            </div>

            <div className="news-page__grid">
              {newsItems.map((item) => (
                <article key={item.href} className="news-page__card">
                  <p className="news-page__source">{item.source}</p>
                  <h3 className="news-page__card-title">{item.title}</h3>
                  <a
                    className="news-page__link"
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.cta}
                  </a>
                </article>
              ))}
            </div>
          </div>
        </motion.section>

        <div className="ed-footer">
          <Footer alternate={true} />
        </div>
      </motion.div>
    </div>
  );
}
